import React from "react";
import {Box} from "@mui/system";
import styles from "../organizationMainStyles";
import {getAccessibilityMode, getLabel} from "../Utilities/organizationSettingsUtils";
import {fragmentId} from "../Utilities/organizationSettingsConstants";
import useGetOrganizationSchedules from "../hooks/useGetOrganizationSchedules";
import SchedulesContainer from "../Utilities/ExpertManagement/SchedulesContainer";
import _ from "lodash";
import NoDataView from "../EmptyStates/NoDataView";
import ExpertManagementEmptyState from "../EmptyStates/ExpertManagementEmptyState";
import TextButton from "../../../common/TextButton";
import IconAdd from "../../../common/IconAdd";
import {Link} from "react-router-dom";

export default function ExpertManagement({organizationId}) {
    const label = getLabel(fragmentId.EXPERT);
    const mode = getAccessibilityMode();
    const {
        schedules,
        loadingSchedules,
        payoutRates,
        loadingPayoutRates,
        pricingRates,
        loadingPricingRates
    } = useGetOrganizationSchedules(organizationId);

    if(_.isEmpty(organizationId) && _.isEmpty(schedules)) {
        return <NoDataView />
    }

    if(loadingSchedules) {
        return (
            <Box sx={styles.sectionWrapper}>
                <ExpertManagementEmptyState/>
            </Box>
        )
    }

    return(
        <Box sx={styles.sectionWrapper}>
            <Box sx={style.sectionHeader}>
               <Box sx={style.desc}>{label.SCHEDULES}</Box>
                <Link to={`/admin/schedules/add?organization=${organizationId}`}>
                    <TextButton
                        label={'Add schedule'}
                        startIcon={<IconAdd style={{color: '#000000'}}  />}
                        sx={style.actionButton}
                    />
                </Link>
            </Box>
            <SchedulesContainer
                organizationId={organizationId}
                payoutRates={payoutRates}
                pricingRates={pricingRates}
                schedules={schedules}
                loadingPayoutRates={loadingPayoutRates}
                loadingPricingRates={loadingPricingRates}
                loadingSchedules={loadingSchedules}
                mode={mode}
            />
        </Box>
    )
}

const style = {
    desc: {
        fontFamily: 'LarsseitMedium',
        fontSize: '20px',
    },
    actionButton: {
        mt: '-7px',
        height: '25px',
    },
    sectionHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid #B5BEBF',
        pt: '10px',
        pb: '26px',
    }
}